<template>
  <a
    :class="['o-link', alignClass]"
    :style="{color : buttonColor}"
    @click.stop><slot/></a>
</template>

<script>
import { mapGetters } from 'vuex'
  export default {
    props: {
      aligned: {
        type: String | undefined,
        default: undefined,
        validator: function(val) {
          return val === 'right' || val === undefined
        }
      }
    },

    computed: {
      ...mapGetters('config', ['buttonColor']),
      alignClass() {
        return this.aligned ? `is-${this.aligned}-aligned` : ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/ObjLinkDefault.vue